export default __webpack_public_path__ + "static/media/logo.9c7c68a2.png";